import { when } from 'lit/directives/when.js';
export function renderIf(condition, ifTrue, ifFalse) {
    return when(condition, () => ifTrue, () => ifFalse);
}
